module.exports = __webpack_public_path__ + "img/solution28802.de11c1af.png";